  $(document).ready(function(){
    $('.carousel-container').slick({
      slidesToScroll: 1,
      slidesToShow: 3.5,
      speed: 350,
      dots: true,
      arrows: true,
      infinite: false,
      prevArrow: `<button class="slide-arrow prev-arrow">
        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="40" fill="none" viewBox="3.58 4.58 16.83 14.83"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 12h12M6 12l5-5m-5 5 5 5"/></svg>
        </button>`,        
      nextArrow: `<button class="slide-arrow next-arrow">
        <svg style="transform: rotate(180deg);" xmlns="http://www.w3.org/2000/svg" width="50" height="40" fill="none" viewBox="3.58 4.58 16.83 14.83"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 12h12M6 12l5-5m-5 5 5 5"/></svg>
        </button>`,
      appendArrows: $('.arrow__container'),
      appendDots: $('.dots__container'),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.2
          }
        }
      ]
    });
  }); 